import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box, Paper, CircularProgress } from '@mui/material';
import { Icon } from '@iconify/react';
interface CancelTransactionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
  transaction: any;
}
export const CancelTransactionDialog: React.FC<CancelTransactionDialogProps> = ({
  open,
  onClose,
  onConfirm,
  transaction
}) => {
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = async () => {
    if (!reason.trim()) {
      setError('Cancellation reason is required');
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      await onConfirm(reason);
      handleClose();
    } catch (err) {
      setError('Failed to submit cancellation request');
    } finally {
      setIsLoading(false);
    }
  };
  const handleClose = () => {
    if (!isLoading) {
      setReason('');
      setError(null);
      onClose();
    }
  };
  if (!transaction) return null;
  return <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth data-id="element-165">
      <DialogTitle sx={{
      borderBottom: '1px solid #E5E7EB',
      pb: 2,
      fontWeight: 700,
      color: '#1F2937'
    }} data-id="element-166">
        Cancel Transaction
      </DialogTitle>
      <DialogContent data-id="element-167">
        <Box sx={{
        mt: 1,
        mb: 3
      }} data-id="element-168">
          <Typography variant="body2" color="text.secondary" data-id="element-169">
            Transaction ID: <strong data-id="element-170">{transaction.id}</strong>
          </Typography>
        </Box>

        <Paper variant="outlined" sx={{
        p: 2,
        mb: 3,
        bgcolor: '#FEF2F2',
        borderColor: '#FCA5A5'
      }} data-id="element-171">
          <Typography variant="body2" color="error.main" fontWeight={500} data-id="element-172">
            Warning: This will send a cancellation request to the checker for
            approval. If approved, the transaction will be marked as CANCELLED.
          </Typography>
        </Paper>

        <TextField label="Cancellation Reason" placeholder="Enter reason for cancellation..." multiline rows={4} fullWidth required value={reason} onChange={e => {
        setReason(e.target.value);
        setError(null);
      }} error={!!error} helperText={error || 'This reason will be reviewed by a checker'} disabled={isLoading} data-id="element-173" />
      </DialogContent>
      <DialogActions sx={{
      borderTop: '1px solid #E5E7EB',
      p: 2
    }} data-id="element-174">
        <Button onClick={onClose} color="inherit" data-id="element-175">
          Close
        </Button>
        <Button variant="contained" onClick={handleConfirm} disabled={isLoading || !reason} sx={{
        backgroundColor: '#AE2A19',
        '&:hover': {
          backgroundColor: '#8B1D0F'
        }
      }} data-id="element-176">
          {isLoading ? <CircularProgress size={24} color="inherit" data-id="element-177" /> : 'Confirm Cancellation'}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default CancelTransactionDialog;